import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ICONS, getIconSize, LogoIcon } from '@talktoast/shared'

export function PublicHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" aria-label="TalkToast Home">
            <LogoIcon size="h-10" alt="TalkToast" className="transition-transform group-hover:scale-110" />
            <span className="text-h3 font-bold text-gray-900 group-hover:text-toast-gold-700 transition-colors">
              TalkToast
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" aria-label="Main navigation">
            <Link
              to="/about"
              className="text-body text-gray-600 hover:text-toast-gold-700 transition-colors font-medium"
            >
              About
            </Link>
            <Link
              to="/beta-signup"
              className="bg-toast-gold-600 hover:bg-toast-gold-700 text-white px-5 py-2.5 rounded-lg font-semibold transition-colors shadow-md hover:shadow-lg"
            >
              Join Beta
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? (
              <ICONS.utility.x className={`${getIconSize('md')} text-gray-700`} />
            ) : (
              <ICONS.utility.menu className={`${getIconSize('md')} text-gray-700`} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 animate-slide-down">
            <nav className="flex flex-col gap-4" aria-label="Mobile navigation">
              <Link
                to="/about"
                className="text-body text-gray-600 hover:text-toast-gold-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/beta-signup"
                className="bg-toast-gold-600 hover:bg-toast-gold-700 text-white px-5 py-3 rounded-lg font-semibold text-center transition-colors shadow-md"
                onClick={() => setMobileMenuOpen(false)}
              >
                Join Beta
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}
